/**
 * Converts SoundCloud URL(s) to iframe(s), with a specific format for iOS/Android
 * @param {string} content - SoundCloud URL(s) separated by commas
 * @returns {string} - iframe code
 */
export var soundcloudAppsIframe = function soundcloudAppsIframe(content) {
  var data = {
    tracksArray: content ? content.split(',') : [],
    tracksIframe: '',
    settings: '&amp;color&#61;%23e0004d&amp;auto_play&#61;false&amp;hide_related&#61;true&amp;show_comments&#61;false&amp;show_user&#61;true&amp;show_reposts&#61;false&amp;show_teaser&#61;false',
    props: 'width="100%" height="20" scrolling="no" frameborder="no" allow="autoplay"',
    domain: 'https://w.soundcloud.com/player/?url&#61;',
    separator: '<div style="height: 16px; width: 100%; display:block">&nbsp;</div>'
  };

  if (data.tracksArray && data.tracksArray.length > 0) {
    if (data.tracksArray.length === 1) {
      data.tracksIframe = "<iframe ".concat(data.props, " src=\"").concat(data.domain).concat(data.tracksArray[0]).concat(data.settings, "\"></iframe>");
    } else {
      data.tracksArray.forEach(function (i, index) {
        data.tracksIframe = "".concat(data.tracksIframe, "<iframe ").concat(data.props, " src=\"").concat(data.domain).concat(i).concat(data.settings, "\"></iframe>").concat(index < data.tracksArray.length - 1 ? data.separator : '');
      });
    }
  }

  return data.tracksIframe;
};
export default {};